import React, { Component } from 'react';
import { mapPlayersToSpecialRibbonProps } from '../VcardMatch/utils/functions';
import SpecialRibbon from '../../../components/RibbonNew/SpecialRibbon';
import api from './../../requests/api/';
import './_styles.scss';

interface IPlayer {
  idTeam: string,
  title: string,
  idPlayer: string
}

interface IPlayerMatch {
  playerDataHome: IPlayer
  playerDataAway: IPlayer
  matchId: string
}

interface IPlayerProps {
  playerData?: IPlayer
  playerDataMatch?: IPlayerMatch
}

export class Player extends Component<IPlayerProps> {
  private playersData: any;
  private playersDataMatch: any;
  public state: any;
  constructor(props: any) {
    super(props)
    this.playersData = [];
    this.playersDataMatch = [];
    this.state = {
      playersData: {},
      playersDataMatch: {}
    }
  }

  async componentDidMount() {
    const { playerDataMatch } = this.props;
    if (playerDataMatch?.matchId) {
      this.getTeamDataMatch();
    } else {
      if (this.props.playerData && this.props.playerData.idTeam !== '') {
        this.getTeamData();
      }
    }
  }

  /**
   * Use only in vcard match
   */
  async getTeamDataMatch() {
    const { playerDataMatch } = this.props || {} as IPlayerMatch;
    const players = await api.getPlayersByMatch(playerDataMatch!.matchId);
    let players1 = [];
    let players2 = [];
    players.homePlayers.unshift(players.homeCoach);
    players.awayPlayers.unshift(players.awayCoach);
    players1 = players.homePlayers;
    players2 = players.awayPlayers;
    this.playersData = mapPlayersToSpecialRibbonProps(players1, { bottomRibbon: 'vcard-carrousel-first-team', ...playerDataMatch!.playerDataHome}, this.props);
    this.playersDataMatch = mapPlayersToSpecialRibbonProps(players2, { bottomRibbon: 'vcard-carrousel-second-team', ...playerDataMatch!.playerDataAway }, this.props);
    this.setState({ playersData: this.playersData, playersDataMatch: this.playersDataMatch });
  }

  async getTeamData() {
    const { playerData = { idTeam: '', idPlayer: ''} } = this.props;
    let data = await api.getTeam(playerData?.idTeam);
    data = this.unionPlayersDirector(data);
    data = this.getFilterPlayerSelected(playerData.idPlayer, data);
    this.playersData = mapPlayersToSpecialRibbonProps(data, playerData,this.props);
    this.setState({ playersData: this.playersData });
  }

  unionPlayersDirector(data: any) {
    data.players.unshift(data.coach);
    let coanchPlayersData = data.players;
    return coanchPlayersData;
  }

  getFilterPlayerSelected(idPlayer: any, data: any) {
    if (idPlayer !== undefined) {
      return data.filter((player: any) => player.id !== idPlayer);
    } else {
      return data;
    }
  }

  render() {
    const { playersData, playersDataMatch } = this.state;
    return (
      <div className="vcard-soccer-players">
        <SpecialRibbon
          {...playersData}
        />
        {playersDataMatch !== undefined && Object.keys(playersDataMatch).length !== 0 &&
          <SpecialRibbon
            {...playersDataMatch}
          />
        }
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardTeam/player.tsx